// extracted by mini-css-extract-plugin
export default {"editingName":"FormTitle_editingName__TwmR4","disabled":"FormTitle_disabled__PQBe+","nameField":"FormTitle_nameField__1RBY7","errorBorder":"FormTitle_errorBorder__JRtiQ"};